import { SuccessExternalLoginType } from '../../../common/login/login.helpers';
import detectBrowser from '../../../utils/detect-browser';
import detectDevice from '../../../utils/detect-device';
import qualityEventsHelpers from '../quality-events.helpers';

export const AUTHENTICATION_EVENTS = {
    wrongAccountLogin(email_from_response: string, currentEmail: string) {
        qualityEventsHelpers.track({
            extra: JSON.stringify({
                email_from_response,
                html_input_value: document.querySelectorAll<HTMLInputElement>('input#formBasicEmail')[0]?.value,
                react_input_value: currentEmail
            }),
            page_url: window.location.href,
            type: 'wrongAccountLogin',
            user_agent: detectBrowser(),
            user_device: detectDevice()
        });
    },
    signUp(type: SuccessExternalLoginType, sourceContext?: Object) {
        qualityEventsHelpers.track({
            type: `signupRequest${type}`,
            ...sourceContext
        });
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    signUpRegular(context: any) {
        qualityEventsHelpers.track({
            type: 'signupRequestRegular',
            ...context
        });
    },
    changeEmail() {
        qualityEventsHelpers.track({
            type: 'changeEmailViaSite'
        });
    },
    changePassword() {
        qualityEventsHelpers.track({
            type: 'changePasswordViaSite'
        });
    },
    forgotPassword() {
        qualityEventsHelpers.track({
            type: 'resetPasswordViaSite'
        });
    },
    finishRegistrationThankYouPageSubmit() {
        qualityEventsHelpers.track({
            page_url: window.location.href,
            type: 'finishRegistration:thankYouPageFormSubmit'
        });
    },
    finishRegistrationSetPasswordFromEmail() {
        qualityEventsHelpers.track({
            type: 'finishRegistration:setPasswordFromEmailLink'
        });
    },
    resetPasswordViaEmail() {
        qualityEventsHelpers.track({
            type: 'resetPasswordViaEmail'
        });
    },
    signUpCompleted() {
        qualityEventsHelpers.track({
            type: 'signupCompleted'
        });
    },
    wrongAccountLoginByValidate(new_id: number, stored_id: number) {
        qualityEventsHelpers.track({
            extra: JSON.stringify({
                new_id,
                stored_id
            }),
            page_url: window.location.href,
            type: 'wrongAccountLogin:byValidate',
            user_agent: detectBrowser(),
            user_device: detectDevice()
        });
    },
    signUpFDL(sourceContext: { source: string }) {
        qualityEventsHelpers.track({
            type: 'signupRequestFDLEmail',
            ...sourceContext
        });
    }
};
